import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom/client"; // Updated import for React 18  
// import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { basicReduxStore } from "./store";

import * as serviceWorker from './registerServiceWorker';

const root = ReactDOM.createRoot(document.getElementById("root")); // Use createRoot instead of render  
root.render(  
    <Provider store={basicReduxStore}>
        <App />
    </Provider> 
);
serviceWorker.unregister();
